import { useEffect } from 'react';

/**
 * Run `onRestore` when the browser shows this page again from its back/forward cache.
 *
 * A login button that redirects to Keycloak sets a busy state and never clears it, because
 * the page is left. Pressing Back restores the page from the cache exactly as it was left,
 * busy state included, so the button would stay on "Weiterleiten…" and disabled. The
 * `pageshow` event with `persisted` is the one signal of that restore.
 */
export function usePageRestore(onRestore: () => void): void {
  useEffect(() => {
    const handler = (event: PageTransitionEvent) => {
      if (event.persisted) onRestore();
    };
    window.addEventListener('pageshow', handler);
    return () => window.removeEventListener('pageshow', handler);
  }, [onRestore]);
}
